import { useEffect, useState } from 'react';
import useCountriesList from '../../hooks/useCountriesList';
import SearchDropdown from './searchDropdown';
interface Props {
  onSelect: any;
  selectedCountry: any;
  isDisabled?: boolean;
}
const CountriesSelect = ({ onSelect, selectedCountry, isDisabled }: Props) => {
  const [countriesList, setCountriesList] = useState<any>([]);
  const countries = useCountriesList();

  useEffect(() => {
    if (countries) {
      const formattedCountriesList: any = countries.map((item: any) => ({
        label: item?.name,
        value: item.code,
      }));
      setCountriesList(formattedCountriesList);
    }
  }, [countries]);
  return (
    <SearchDropdown
      id={'country-dropdown'}
      isDisabled={isDisabled}
      placeholder={'Countries'}
      selectedValue={selectedCountry}
      options={countriesList && countriesList}
      onSelect={(item) => {
        onSelect(item.value);
      }}
    />
  );
};

export default CountriesSelect;
